module.exports = __webpack_public_path__ + "static/media/ap.85d8dea0.png";